import { useAtomValue } from "jotai";
import { sessionAtom, currentAccountIdAtom } from "@zapier/canvas-state";

export default function useIsOwnerOrSuperAdmin() {
  const currentAccountId = useAtomValue(currentAccountIdAtom);
  const session = useAtomValue(sessionAtom);

  if (!session) return false;

  const accountRole = session.roles?.find(
    (role) => role.account_id === currentAccountId,
  );

  return accountRole?.role === "owner" || accountRole?.role === "super_admin";
}
